import { CreditAppService } from './../../../../services/credit-app.service';
import { NextComponentService } from './../../../../services/next-component.service';
import { PersonalInfoComponent } from './../personal-info/personal-info.component';
import { ComponentName } from './../../../../enum/component-name.enum';
import { ComponentGroup } from './../../../../enum/component-group.enum';
import { StepComponent } from './../stepcomponent.class';
import { IComponentDetails } from './../../../../interfaces/component-details.interface';
import { PreQualificationInformation, TargetVehicleInformation } from './../../../../interfaces/credit-application-config.interface';
import { Component, OnInit, Inject } from '@angular/core';
import { NotificationsService } from '../../../../services/notifications.service';
import { NotificationType } from '../../../../interfaces/notification.interface';
import { IConfig } from '../../../../interfaces/config.interface';
import { ThankyouInfo } from '../../../../interfaces/credit-application-config.interface';
import {getBackButton} from '../../../../utils/utils.functions';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'dt-confirmation-page',
  templateUrl: './confirmation-page.component.html',
  styleUrls: ['./confirmation-page.component.scss'],
  standalone: false
})
export class ConfirmationPageComponent implements OnInit {
  thankyouInfo: ThankyouInfo;
  confirmationInfo: PreQualificationInformation;
  isBuyNow: boolean;
  public TradeinStarted: boolean;
  public TradeInComplete: boolean;
  public OfferAmount: number;
  public OfferExpires: Date;
  vehicleInfo: TargetVehicleInformation;
  ctaDeactivate = false;
  isLegacyCreditApp:boolean = false;
  constructor(
    @Inject('config') public config: IConfig,
    private notificationService: NotificationsService,
    private nextComponentService: NextComponentService,
    private creditAppService: CreditAppService,
    private ngxService: NgxUiLoaderService
  ) { }

  ngOnInit() {
    if (this.config && this.config.Sitecore) {
      this.thankyouInfo = this.config.Sitecore.CreditApplicationConfig.ThankyouInfo;
      this.confirmationInfo = this.config.Sitecore.CreditApplicationConfig.PreQualificationInformation;
      this.isBuyNow = this.config.Sitecore.isBuyNow;
      this.vehicleInfo = this.getVehicleInformation();
      this.isLegacyCreditApp = this.config.Sitecore.isLegacyCreditApp;
    }
    if (typeof (window as any).applyHeightToContainer === 'function') {
      (window as any).applyHeightToContainer(true);
    }
    /* istanbul ignore next */
    setTimeout(() => {
      this.notificationService.broadcastNotification({
        Message: 'Review page will be loaded',
        Type: NotificationType.confirmation,
      });
    }, 300);
    document.dispatchEvent(new CustomEvent('SHOW_SUBMITTED_BANNER', {
      detail: {}
    }));

  }

  public getVehicleInformation() {
    let leadInfo:any;
    leadInfo = this.config.Sitecore.PreQualLeadInfo;
    if(leadInfo.vin === ''){
      /* istanbul ignore next */
      this.creditAppService.YMMTDetails$.subscribe(res => {
        if(res){
          leadInfo = {
          model: res?.model ? res.model : '',
          make: res?.make ? res.make : '',
          year: res?.year ? parseInt(res.year) : 0,
          vehicleImage :  res?.vehicleImage ? res.vehicleImage : '',
        
        }
        }
      })
     
    }
      /* istanbul ignore next */
      return {
        MakeModelName: `${leadInfo.year > 0 ? leadInfo.year : ''} ${leadInfo.make
          } ${leadInfo.model} `,
        StyleName: leadInfo?.styleName ? leadInfo.styleName :'',
        VehicleImage: leadInfo.vehicleImage,
      };
  }
  /* istanbul ignore next */
  goNext() {
    this.ctaDeactivate = true;
    try {
      getBackButton();
      this.ngxService.stopAllLoader('creditApplication');
      this.ngxService.startLoader('creditApplication');
      if (this.isBuyNow && (window as any).buynow) {
        (window as any).buynow.navigation.moveNext();
      }
    } catch (e) {
      console.log(e);
      this.ctaDeactivate = false;
      this.ngxService.stopAllLoader('creditApplication');
    }
  }

  goPrev() {
    try {
      let nextComponent: IComponentDetails;
      nextComponent = {
        groupName: ComponentGroup.PersonalInfo,
        component: new StepComponent(PersonalInfoComponent,
          ComponentName.PersonalInfoComponent, ComponentGroup.PersonalInfo, true),
        componentName: ComponentName.PersonalInfoComponent,
      };

      // reset ids to create a new credit app on first submit
      if(this.isLegacyCreditApp){
        this.creditAppService.LegacyCreditApplication.shortForm.dealParameters.creditAppId = null;
        this.creditAppService.LegacyCreditApplication.shortForm.dealParameters.creditShortFormId = null;
        this.creditAppService.LegacyCreditApplication.creditApplicationCompleted = false;
        this.creditAppService.LegacyCreditApplication.creditAppId = null;
      }else{
        this.creditAppService.CreditApplication.shortForm.dealParameters.creditAppId = null;
        this.creditAppService.CreditApplication.shortForm.dealParameters.creditShortFormId = null;
        this.creditAppService.CreditApplication.creditApplicationCompleted = false;
        this.creditAppService.CreditApplication.creditAppId = null;
      }
      
      this.notificationService.broadcastNotification({
        Message: 'New credit app will be loaded',
        Type: NotificationType.startingNewCreditApp
      });
      this.nextComponentService.loadComponent(nextComponent);
    } /* istanbul ignore next */ catch (e) {
      /* istanbul ignore next */
      console.error(e);
    }
  }

  /* istanbul ignore next */
  goToSMC(){
    window.location.href = window.location.origin + '/sell-my-car';
  }
}
